module.exports = __webpack_public_path__ + "img/logo_white_200x200.fd6c196d.png";